// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"1caf75e0","534":"cf8823f2","572":"1b7941be","824":"6fd9f1eb","852":"bb72c60a"}[chunkId] + ".chunk.js";
};